import GoogleAuthCallback from './google-callback';

export default GoogleAuthCallback;
